"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBSCRIBE_OPTION_LABEL = void 0;
const SUBSCRIBE_OPTION_LABEL = exports.SUBSCRIBE_OPTION_LABEL = 'subscribe-option-label';
